// extracted by mini-css-extract-plugin
module.exports = {"paper":"Timeline_paper__3ASUs","paper2":"Timeline_paper2__tQtuF"};